import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import Hero, { heroImgStyles } from '~components/Hero';
import { ConstrainedText } from '~components/Text';

// Page Navigation
import PageNav from '~components/PageNav';
import CovidResponseCard from '~components/PageCard/CovidResponseCard';
import CaleahCard from '~components/PageCard/CaleahCard';

const StubPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="Myrzah, mère de Caleah" desc="Description" />
      <Hero title="Myrzah, mère de Caleah">
        <StaticImage style={heroImgStyles} src="../../images/myrzah.jpg" alt="" />
      </Hero>
      <div tw="container">
        <ConstrainedText>
        Le DT1 a considérablement changé ma vie de parent. Je m’inquiète constamment de la santé de ma fille, bien plus qu’avant le diagnostic. J’ai plus de connaissances sur le corps humain et les valeurs nutritives des aliments.
        </ConstrainedText>
        <ConstrainedText>
        J’ai l’impression que j’ai dû devenir une infirmière spécialisée dans le DT1 du jour au lendemain et faire partie de son système de soutien. Il est particulièrement important d’avoir un bon système de soutien composé de la famille et des amis.
        </ConstrainedText>
        <ConstrainedText>
        Les gens ont l’impression qu’après le diagnostic et la consultation de l’équipe médicale, le DT1 est sous contrôle. Ils ne comprennent pas que c’est une tâche quotidienne pour maintenir le contrôle. Nous devons accélérer le rythme de recherche sur le DT1 afin d’offrir une meilleure qualité de vie aux personnes qui en sont atteintes et d’éviter éventuellement de futurs diagnostics.
        </ConstrainedText>
        <ConstrainedText>
        Pour moi, un traitement curatif signifierait que ma fille n’aurait plus à s’inquiéter de son taux de glycémie 24 heures sur 24 et 7 jours sur 7. Elle pourrait sortir avec ses amis sans avoir à se soucier de son niveau d’activité, de ce qu’elle mange, etc. Et bien sûr, je m’inquiéterais beaucoup moins lorsqu’elle sortirait avec ses amis.
        </ConstrainedText>
        <ConstrainedText>
        Le message que je souhaite transmettre aux autres parents d’enfants atteints de DT1 récemment diagnostiqués est le suivant : après le choc du diagnostic et la période accablante où vous devez tout apprendre, il est important d’accepter que cette maladie fasse désormais partie de la vie de votre enfant et de sa famille. L’acceptation est essentielle pour continuer à avancer, surtout les jours où nous sommes complètement découragés.
        </ConstrainedText>
        <PageNav previous={<CovidResponseCard />} next={<CaleahCard />} />
      </div>
    </Layout>
  );
};

export default StubPage;
